import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from '../../core/style/gstheme';
import withGS from '../../core/withGShoc';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import { isRTL } from '../../core/utils/utils';

class TemplateCard extends React.Component {

    render() {

        const { classes, data, defaultLang, onToggleView, id, visible, jumpToCard } = this.props;

        const templateName = data.label[defaultLang] || "No name available";
        const rtl = isRTL(defaultLang);

        return (
            <div
                style={{
                    backgroundColor: 'white',
                    marginRight: 12,
                    marginBottom: 12,
                    borderRadius: 4,
                    width: 240
                }}>
                <Card data-test={"template-card"}
                    className={classes.gsCard}
                    onClick={() => jumpToCard(id)}
                    style={{ height: '100%', ...(!visible) && { backgroundColor: '#e5e5e5' } }}>
                    <CardHeader
                        data-test="template-card-header"
                        classes={{
                            root: classes.gsCardInner
                        }}
                        titleTypographyProps={{
                            className: classes.gsCardHeader
                        }}
                        disableTypography
                        title={
                            <div>
                                <div
                                    data-test="template-card-body"
                                    style={{ display: 'flex' }}
                                    dir={rtl ? "rtl" : null}>
                                    <div data-test="template-card-title" variant="body2" style={{ flex: 1 }}>
                                        {templateName}
                                    </div>
                                    <div data-test="visibility"
                                        className="gsCardStatus"
                                        style={{ flex: '0 0', verticalAlign: 'middle' }}
                                        onClick={() => onToggleView(id)}>
                                        <Tooltip data-test={"visible-" + visible} placement="right" title={visible ? 'Hide template' : 'Show tempate'}>
                                            {visible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                        </Tooltip>
                                    </div>
                                </div>
                            </div>}
                    />
                </Card>
            </div>
        );
    }
}

TemplateCard.defaultProps = {
    isReadOnly: false
};

TemplateCard.propTypes = {
    classes: PropTypes.object,
    id: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    visible: PropTypes.bool,
    jumpToCard: PropTypes.func.isRequired,
    onToggleView: PropTypes.func.isRequired,
    defaultLang: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired
};

export default withStyles(styles)(withGS(TemplateCard));